module.exports = __webpack_public_path__ + "static/img/case4.e42c934.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/h5/case4.png
// module id = 1KVV
// module chunks = 34